import { render, staticRenderFns } from "./assign-authority.vue?vue&type=template&id=9a7e5ca8&"
import script from "./assign-authority.component.ts?vue&type=script&lang=ts&"
export * from "./assign-authority.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports